module.exports = __webpack_public_path__ + "img/Blood Cells.7a8598e.png";